import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {RecensioniService} from '../../shared/recensioni.service';
import {AngularFirestore} from '@angular/fire/firestore';
import {Router} from '@angular/router';


@Component({
  selector: 'app-putrecensione',
  templateUrl: './putrecensione.component.html',
  styleUrls: ['./putrecensione.component.css']
})
export class PutrecensioneComponent implements OnInit {

  constructor(public afAuth: AngularFireAuth , public recensioniService: RecensioniService,
              private firestore: AngularFirestore, public router: Router) { }
  recensioni;
  ngOnInit() {
  }

  onSubmit(){

    this.firestore.collection('recensioni').add({
      nome: this.recensioniService.form.value.nome,
      cognome: this.recensioniService.form.value.cognome,
      description: this.recensioniService.form.value.description,
      punteggio: this.recensioniService.form.value.punteggio
    })
        .then(res => {
          console.log(res);
          this.recensioniService.form.reset();
        })
        .catch(e => {
          console.log(e);
        });
  }


}
